import api from '@/configs/GlobalRequestHandler.js';

export default {
  getDashboardMetrics: (page = 1, per_page = 20) => {
    return api.getRequest(`/user/affiliate/dashboard?page=${page}&per_page=${per_page}`);
  },
  getIndicatedCampaigns: (userId) => {
    return api.getRequest(`/user/affiliate/indicated/${userId}/campaigns`);
  },
  getCampaignBuyers: (campaignId) => {
    return api.getRequest(`/user/affiliate/indicated/campaign/${campaignId}/buyers`);
  },
  
  // CAMPAIGN AFFILIATES ROUTES
  getMarketplace: (page, search) => {
    return api.getRequest(`/campaign_affiliates/marketplace?page=${page}&search=${search}`);
  },
  getMarketplaceTop5: () => {
    return api.getRequest(`/campaign_affiliates/marketplace/top5`);
  },
  getMarketplaceDetails: (id) => {
    return api.getRequest(`/campaign_affiliates/marketplace/details?id=${id}`);
  },
  joinCampaign: (campaignId) => {
    return api.postRequestWithBody(`/campaign_affiliates/join`, { campaign_id: campaignId });
  },
  getMyAffiliations: () => {
    return api.getRequest(`/campaign_affiliates/my`);
  },
  
  // ADMIN
  getAffiliateConfig: (campaignId) => {
    return api.getRequest(`/admin/campaign_affiliates/config?id=${campaignId}`);
  },
  updateAffiliateConfig: (data) => {
    return api.putRequestWithBody(`/admin/campaign_affiliates/config`, data);
  },
  updateAffiliateStatus: (affiliationId, status) => {
    return api.putRequestWithBody(`/admin/campaign_affiliates/${affiliationId}/status`, { status });
  },

  // OFF-WALLET COMMISSION LEDGER
  getCampaignCommissions: (campaignId) => {
    return api.getRequest(`/admin/campaign_affiliates/commissions/${campaignId}`);
  },
  markCommissionPaid: (commissionId, paidNote) => {
    return api.putRequestWithBody(`/affiliate-commissions/${commissionId}/mark-paid`, {
      paid_note: paidNote || null,
    });
  },
  getMyEarnings: () => {
    return api.getRequest(`/user/campaign-affiliate/earnings`);
  },
  updateMyPix: (affiliationId, data) => {
    return api.putRequestWithBody(`/campaign_affiliates/${affiliationId}/pix`, data);
  },

  // Platform affiliate balance / saque (fora da Carteira do Sistema)
  getAffiliateWallet: () => {
    return api.getRequest('/affiliate/wallet');
  },
  requestAffiliateWithdraw: (body) => {
    return api.postRequestWithBody('/affiliate/withdraw', body);
  },
  getAffiliateWithdrawals: (page = 1, per_page = 5) => {
    return api.getRequest(`/affiliate/withdrawals?page=${page}&per_page=${per_page}`);
  },
  getAdminAffiliateWithdrawals: (params) => {
    return api.getRequest('/admin/affiliate-withdrawals', { params });
  },
  updateAffiliateWithdrawalStatus: (id, status, rejection_reason) => {
    return api.putRequestWithBody(`/admin/affiliate-withdrawals/${id}/status`, {
      status,
      rejection_reason,
    });
  },
  getAdminPlatformAffiliates: (params) => {
    return api.getRequest('/admin/affiliates', { params });
  },
}
